import { Info } from "lucide-react-native";
import React from "react";

import { Box } from "../../ui/box";
import { Icon } from "../../ui/icon";
import { Tooltip, TooltipContent, TooltipText } from "../../ui/tooltip";

type Props = {
  content: string;
};

/**
 * Web counterpart of `InfoHint.tsx`: hover reveals the explanation in a
 * Tooltip instead of a press-triggered Popover.
 */
const InfoHint = React.memo(({ content }: Props) => {
  return (
    <Tooltip
      placement="top"
      trigger={(triggerProps) => (
        <Box {...triggerProps} aria-label="Más información">
          <Icon as={Info} size="xs" className="text-typography-400" />
        </Box>
      )}
    >
      <TooltipContent className="max-w-64">
        <TooltipText>{content}</TooltipText>
      </TooltipContent>
    </Tooltip>
  );
});

InfoHint.displayName = "InfoHint";

export default InfoHint;
